import script from "./Partner.vue?vue&type=script&setup=true&lang=js"
export * from "./Partner.vue?vue&type=script&setup=true&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=f1d02d82&lang=less&scoped=true"
script.__scopeId = "data-v-f1d02d82"

export default script